import { FC } from 'react'
import cls from '../styles/StaticContent.module.scss'
import { HeaderBar } from '@/components/HeaderBar'
import { GetServerSideProps } from 'next'
import { SEO } from '@/components/SEO'
import Link from 'next/link'
import { Footer } from '@/components/Footer'

interface SSP {
  insideTeams: boolean
}

import { articles } from '@/utils/articleData';

const ArticlesIndex: FC<SSP> = ({ insideTeams }) => {
  return (
    <>
      <SEO
        title="TeamsReminder - Articles and Guides"
        description="Explore our collection of articles, tutorials, and guides about Microsoft Teams reminders, productivity tips, and best practices for team communication."
        keywords="Microsoft Teams articles, Teams productivity, Teams reminder guides, TeamsReminder tutorials"
      />
      <HeaderBar showLogOutButton={false} className={insideTeams ? '!hidden' : ''} />
      <div className={cls.container}>
        <h1>TeamsReminder - Articles and Guides</h1>
        
        <p>
          Explore our collection of articles, tutorials, and guides to help you maximize your 
          productivity with Microsoft Teams and TeamsReminder. Learn how to set up effective 
          reminders, improve team communication, and implement best practices for remote 
          and hybrid work environments.
        </p>

        <div className="mt-8 space-y-8">
          {articles.map((article) => (
            <div key={article.slug} className="border-b pb-6">
              <h2 className="text-xl font-bold mb-2">
                <Link href={`/article/${article.slug}`} className="hover:underline">
                  {article.title}
                </Link>
              </h2>
              <p className="text-gray-600 dark:text-gray-300">{article.description}</p>
              <Link href={`/article/${article.slug}`} className="mt-2 inline-block text-blue-600 dark:text-blue-400 hover:underline">
                Read the full article →
              </Link>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </>
  )
}

export default ArticlesIndex

export const getServerSideProps: GetServerSideProps<SSP> = async (context) => {
  return {
    props: {
      insideTeams: !!context.query.teamsEmail,
    },
  }
}